import { Component, Input, OnChanges, OnInit, SimpleChanges, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import {
  Civility,
  Family,
  IntUser,
  IntUserPerimeters_XRP,
  IntUsersService,
  IntUserStatut,
  IntUserStatutHistory,
  Profil,
  PS_Lst_IntUsers_Result,
  SharedDataService,
  IntUserUpdateParameters,
  Contact,
  SimpleReponseResult,
  PS_PAFX_DR_Result
} from 'ngx-paf-common';
import { forkJoin, Subject } from 'rxjs';

@Component({
  selector: 'int-user-detail',
  templateUrl: './int-user-detail.component.html',
  styleUrls: ['./int-user-detail.component.scss']
})
export class IntUserDetailComponent implements OnInit, OnChanges {

  constructor(
    public sharedDataSvc: SharedDataService,
    private intUserSvc: IntUsersService) { }


  @Input() closeWindowSubject: Subject<any>;
  @Input() windowTitleSubject: Subject<string> = new Subject<string>();
  @Input() lstStatuts: IntUserStatut[] = [];
  @Input() lstFamilies: Family[] = [];
  @Input() lstPerimeters: IntUserPerimeters_XRP[] = [];
  @Input() lstProfils: Profil[] = [];
  @Input() lstUserEtbsXRP: PS_PAFX_DR_Result[] = [];
  @Input() lstAllEtbsXRP: PS_PAFX_DR_Result[] = [];
  @Input() lstIntUsers: PS_Lst_IntUsers_Result[] = [];

  @Input() intUserId: number;
  @Input() readOnly:boolean=true;
  //public model: IntUserUpdateParameters = new IntUserUpdateParameters();

  
  canDelete:SimpleReponseResult={ 
    Ok : false, 
    Message:'En attente de contrôle', 
    ExtendDatas:null, 
    Id:0, 
    StackTrace:null
  };

  public model? : IntUserUpdateParameters;
  get intUser():IntUser | undefined {
    return this.model.IntUser;
  }
  

  get inputControlReadonly():boolean{
    return this.readOnly==true || this.isLocked;
  }




  @ViewChild('frmGeneral') frmGeneral: NgForm;
  @ViewChild('frmPerimeters') frmPerimeters: NgForm;
  @ViewChild('frmFamilies') frmFamilies: NgForm;



  ngOnInit(): void {
    //this.intUser = new IntUser();
    this.reload();
    if (this.lstFamilies) this.lstFamilies.sortObject('Cod2');
    this.revealErrors();
    // compute the stable data arrays for multiselects
    this.updatePerimeterLists();

    setTimeout(() => {
      [this.frmGeneral, this.frmPerimeters, this.frmFamilies].forEach((f: NgForm) => { if (f?.form) f.form.markAsPristine });
    }, 0);
  }

  
  get isLocked(): boolean {
    return (this.lstStatuts.find(st => st.Id == this.model?.IntUserStatutHistory?.StatutId)?.Cod != 'ACTIF');
  }
  set isLocked(value: boolean) {
    if (this.model?.IntUserStatutHistory) {
      const newStatut: IntUserStatut = this.lstStatuts.find(st => st.Cod == (value ? 'BLOQUE' : 'ACTIF'));
      this.model.IntUserStatutHistory.StatutId = newStatut.Id;
      this.model.IntUserStatutHistory.IntUserStatut = newStatut;
    }
  }
  get statutComment(): string {
    return this.model?.IntUserStatutHistory?.Comments || '';
  }
  set statutComment(value: string) {
    if (this.model?.IntUserStatutHistory) this.model.IntUserStatutHistory.Comments = value;
  }

  get isAlreadyModified(): boolean {
    return (this.intUser?.IntUserStatutHistories || []).length > 1;
  }

  get UserMajLib(): string {
    if (!this.isAlreadyModified) {
      return '';
    } else {
      return this.lstIntUsers.filter(u => u.Id == this.model.IntUserStatutHistory.IntUserIdMaj).map(u => (u.Firstname || ' ').substring(0, 1) + ' ' + u.Lastname).join();
    }
  }

  allFamiliesLine:any={
    Id:0,
    Cod:'000000000',
    Cod2:'00',
    Segment: 'Toutes les familles',
    FamilyCod:'*'
  }
  get lstFamiliesWithStar(): Family[] {    
    return [this.allFamiliesLine].concat(this.lstFamilies);
  }
  public createMode : boolean = true;

  reload(id?:number): void {
    this.createMode = true;
    this.model = null;
    this.acheteurReferent = null;
    if (id!=null) this.intUserId = id;
    if ((this.intUserId || 0) == 0) {
      this.initCreateMode();
      // also reset lists
      this.updatePerimeterLists();
      return;
    }
    forkJoin([
      this.intUserSvc.IntUser(this.intUserId),
      this.intUserSvc.canDelete(this.intUserId),
    ]).subscribe(results => {
        this.model = new IntUserUpdateParameters();
        this.model.IntUser = results[0];

        this.selectedSocs = this.lstUserEtbsXRP.filter(item=> this.model.IntUser.IntUserPerimeters_XRP.some(userSoc=>userSoc.Soc_XRP== item.SocCod)).distinctValues('SocCod');
        this.model.Etbs = this.lstUserEtbsXRP
        .filter(item=> this.model.IntUser.IntUserPerimeters_XRP.some(userEtb=>item.EtbCod==userEtb.Etb_XRP && item.SocCod==userEtb.Soc_XRP)).distinctValues('EtbLib');
        
        this.canDelete=results[1];
        this.createMode = false;
        if ((this.intUser?.IntUserStatutHistories || []).length > 0) {
          this.intUser.IntUserStatutHistories.sortObjectDesc('Id');
          this.model.IntUserStatutHistory = Object.assign({}, this.intUser.IntUserStatutHistories[0]);
        }
        if (this.intUser?.Families) this.intUser.Families = this.intUser?.Families.filter(f => (f.FamilyCod || '') == '');//on ne conserve que les segments
        if (this.intUser?.Families.length==this.lstFamilies.length) this.intUser.Families = [this.allFamiliesLine];
        if (this.intUser?.IntUserPerimeters_XRP || [].length > 0) {
          
        }
        this.updateBoxTitle();
        this.onProfilChange(true);
        this.CheckReferent();

        // recompute the dropdown contents now that selections have been restored
        this.updatePerimeterLists();
      });
  }

  initCreateMode() {
    this.createMode = true;
    this.model = new IntUserUpdateParameters();
    this.model.IntUser = new IntUser();
    this.intUser.Id = 0;
    this.intUser.ContactId = 0;
    this.intUser.Contact = new Contact();
    this.intUser.IntUserStatutHistories = [];
    this.model.IntUserStatutHistory = new IntUserStatutHistory();
    this.model.IntUserStatutHistory.StatutId = 1; //Actif par defaut
    this.updateBoxTitle();
  }
  CheckReferent(): void {
    if (this.referentRequis && this.lstReferents.length > 0) {
      let searchId= this.acheteurReferent != null ? this.acheteurReferent.Id : this.intUser.AchRefId;
      this.acheteurReferent = this.lstReferents.find(r => r.Id == searchId);
    }
  }

  familyDisplay(family: Family): string {
    return family.Cod.substring(0, 2) + ' - ' + family.Segment;
  }

  get civility(): Civility {
    return this.intUser?.Contact?.Civility;
  }
  set civility(value: Civility) {
    if (this.intUser?.Contact) {
      this.intUser.Contact.Civility = value;
      this.frmGeneral?.form.markAsDirty();
    }
  }

  onProfilChange(isReloading: boolean = false): void {
    if (this.isAdmin) {
      
      this.intUser.Families = this.lstFamiliesWithStar.filter(f => f.Id == 0);
      if (!isReloading) {
        this.frmFamilies.form.markAsDirty();
        this.frmPerimeters.form.markAsDirty();
      }
    }
    this.revealErrors();
  }

  revealErrors(): void {
    setTimeout(() => {
      [this.frmGeneral, this.frmPerimeters, this.frmFamilies].forEach((f: NgForm) => { if (f) this.sharedDataSvc.formRevealErrors(f) });
    }, 0);

  }


  get switchStatutColor(): string {
    return 'switchery-' + this.isLocked ? 'success' : 'danger';
  }




  public boxTitle: string = '';
  updateBoxTitle(): void {
    if (!this.intUser?.Contact) {
      this.boxTitle = '';
    } else if (this.createMode) {
      this.boxTitle = 'Création d\'un nouveau compte interne';
    } else {
      this.boxTitle = this.intUser.Contact.Firstname + ' ' + this.intUser.Contact.Lastname + ' (' + this.intUser.UtiGid + ')';
    }
    this.windowTitleSubject.next(this.boxTitle);
  }

  get referentRequis(): boolean {
    //return this.lstProfils.filter(p => ['ASSISTANT', 'DEMANDEUR', 'ACH_OPERAT', 'ACH_OPERAT_2'].indexOf(p.Cod) >= 0).map(p => p.Id).indexOf(this.intUser?.ProfilId) >= 0;
    return this.lstProfils.filter(p => ['ASSISTANT', 'DEMANDEUR', 'ACH_OPERAT_2'].indexOf(p.Cod) >= 0).map(p => p.Id).indexOf(this.intUser?.ProfilId) >= 0;
  }

  acheteurReferent:PS_Lst_IntUsers_Result | null = null;

 private _lstReferents: PS_Lst_IntUsers_Result[]= [];
 get lstReferents(): PS_Lst_IntUsers_Result[] {
  return this._lstReferents;
 }
  reloadLstReferents(): void {
    if (!this.referentRequis) {
      this._lstReferents = [];
      return;
    }
    const achOperatId = this.lstProfils.find(p => p.Cod == 'ACH_OPERAT').Id;
    let ret: PS_Lst_IntUsers_Result[]= this.lstIntUsers.filter(u => u.ProfilId == achOperatId);    
    ret.sortObject(['Lastname', 'Firstname']);
    this._lstReferents = ret;
    this.CheckReferent();
  }

  get familiesRequired(): boolean {
    return false;// this.lstProfils.filter(p => ['ACH_FAMHA', 'ADMIN'].indexOf(p.Cod) >= 0).map(p => p.Id).indexOf(this.intUser?.ProfilId) >= 0;
  }

  get perimetersRequired(): boolean {
    return this.lstProfils.filter(p => ['ASSISTANT', 'DEMANDEUR', 'ACH_OPERAT', 'ACH_OPERAT_2', 'ACH_FAMHA', 'QUAL', '3SE', 'ADMIN'].indexOf(p.Cod) >= 0).map(p => p.Id).indexOf(this.intUser?.ProfilId) >= 0;
  }

  get isAdmin(): boolean {
    return this.lstProfils.some(p => p.Cod == 'ADMIN' && this.intUser?.ProfilId == p.Id);
  }

  valider(): void {
    if (!this.intUser) return;
    this.sharedDataSvc.WindowLock();

    //Si on a sélectionné des sociétés sans préciser un établissement, on met l'établissement '*' correspondant si présent
    this.selectedSocs.filter(soc=> !this.model.Etbs.some(e=>e.SocCod==soc.SocCod))
      .forEach(missingSoc=>{
        let allEtb:PS_PAFX_DR_Result = this.lstUserEtbsXRP.find(e=>e.SocCod==missingSoc.SocCod && e.EtbCod=='*');
          if (allEtb!=undefined) {
            this.model.Etbs.push(allEtb);
          }
      });
    this.model.IntUser.AchRefId = (this.referentRequis && this.acheteurReferent != null) ? this.acheteurReferent.Id : 0;
    this.intUserSvc.update(this.intUserId, this.model)
      .subscribe({
        next : result => {
          this.sharedDataSvc.WindowUnlock();
          this.closeWindow(false);
        },
        error:(reason: any) => {
          this.sharedDataSvc.alert(reason.error);
        }
      });
  }

  continuer(): void {
    if (!this.intUser) return;
    if (this.createMode && this.frmGeneral.valid) {
      this.sharedDataSvc.WindowLock();
      this.intUserSvc.add(this.intUser)
        .subscribe({
          next: (result: IntUser) => {
            this.sharedDataSvc.WindowUnlock();
            this.reload(result.Id);
          },
          error: (reason: any) => {
            this.sharedDataSvc.alert(reason.error);
          }
        });
    }
  }

  annuler(): void {
    let isDirty: boolean = [this.frmGeneral, this.frmPerimeters, this.frmFamilies].some((f: NgForm) => {
      if (f?.form?.dirty) {
        return true;
      } else {
        return false;
      }
    });
    if (isDirty && !this.readOnly) {
      this.sharedDataSvc.confirm('Ignorer les modifications apportées ?', () => { this.closeWindow(true) }, null);
    } else {
      this.closeWindow(true);
    }
  }

  supprimer():void {
    this.sharedDataSvc.confirm('Confirmer la suppression du compte interne ?', () => { 
      this.intUserSvc.delete(this.intUserId).subscribe((result:SimpleReponseResult)=>{
        if (!result.Ok){
          this.sharedDataSvc.alert(result.Message);
        } else {
          this.sharedDataSvc.alert("Compte interne supprimé",()=>{this.closeWindow(false)});
        }
      });
     }, null);
  }
  
  closeWindow(topAnnuler: boolean): void {
    this.closeWindowSubject.next({reload: this.readOnly==false && !topAnnuler});
  }


  get isSelf(): boolean {
    return this.sharedDataSvc?.loggedIntUser?.Id == this.intUserId;
  }
  
  selectedSocs?:PS_PAFX_DR_Result[] | null=[];

  /** recalc the arrays used as [data] for the multiselects; kept as fields so
   * the object identity doesn't change during change detection/scrolling.
   * Call whenever selectedSocs, model.Etbs, or lstEtbsXRP are updated. */
  private updatePerimeterLists(): void {
    this.socsDispo = this.computeSocsDispo();
    this.etbsDispo = this.computeEtbsDispo();
    this.handleFilterSocs('');
    this.handleFilterEtbs('');
  }



  ngOnChanges(changes: SimpleChanges): void {
    if (changes['intUserId']) {
      this.reload(this.intUserId);
    }
    if (changes['lstFamilies']) {
      if (this.lstFamilies) this.lstFamilies.sortObject('Cod2');
    }
    if (changes['lstEtbsXRP'] && !changes['lstEtbsXRP'].isFirstChange()) {
      // underlying dataset changed, recompute dropdown contents
      this.updatePerimeterLists();
    }
  }
  
  // avoid recalculating arrays on every change detection (virtual scroll jumps to top when reference changes)
  // the getters above returned a new array each time; store the lists instead
  public socsDispo: PS_PAFX_DR_Result[] = [];
  public etbsDispo: PS_PAFX_DR_Result[] = [];

  private computeSocsDispo(): PS_PAFX_DR_Result[] {
    if (this.selectedSocs?.some(s => s.SocCod == '*')) {
      return [];
    }
    return this.lstUserEtbsXRP
      .filter(s => !this.selectedSocs?.some(ss => ss.SocCod == s.SocCod))
      .distinctValues('SocCod');
  }

  private computeEtbsDispo(): PS_PAFX_DR_Result[] {    
    if (this.selectedSocs?.some(s => s.SocCod == '*' && s.EtbCod == '*')) {
      return this.lstUserEtbsXRP.filter(e => e.SocCod == '*' && e.EtbCod == '*');
    }
    return this.lstUserEtbsXRP
      .filter(
        etb =>
          this.selectedSocs?.some(s => s.SocCod == etb.SocCod) &&
          !this.model.Etbs.some(
            item =>
              item.SocCod == etb.SocCod &&
              (item.EtbCod == '*' || item.EtbCod == etb.EtbCod)
          )
      )
      .distinctValues('EtbLib');
  }


  onSocsChange(selectedSocs: PS_PAFX_DR_Result[]): void {
    //Si on sélecionne la société '*', on ne peut pas en sélectionner d'autres et on force les établissements à '*' également
    if (this.selectedSocs.some(s=>s.SocCod=="*") ){
      this.selectedSocs = this.lstUserEtbsXRP.filter(e=>e.SocCod=='*' && e.EtbCod=='*');
      this.model.Etbs = this.lstUserEtbsXRP.filter(e=>e.SocCod=='*' && e.EtbCod=='*');
    }
    if (this.model.Etbs.some(s=>s.EtbCod=="*") ){
      //Si on sélectionne l'établissement '*' sur certaines sociétés, on ne peut pas en sélectionner d'autres pour cette meme société
      let starSocs=this.model.Etbs.filter(s=>s.EtbCod=="*").map(s=>s.SocCod);
      this.model.Etbs = this.model.Etbs.filter(e=>starSocs.indexOf(e.SocCod)<0 || e.EtbCod=='*').distinctValues('EtbLib');
    }
    //On s'assure que les établissements sélectionnés soient accessibles pour les sociétés sélectionnées
    this.model.Etbs = this.model.Etbs
        .filter(item=> this.selectedSocs.some(uSoc=> item.SocCod==uSoc.SocCod || uSoc.SocCod=='*' || (item.EtbCod=='*' && item.SocCod==uSoc.SocCod))).distinctValues('EtbLib');

    // update available combo lists; keep same references so scroll position is preserved
    this.updatePerimeterLists();
  }

  onEtbsChange(selectedEtbs: PS_PAFX_DR_Result[]): void {
    //Si on sélecionne la société '*', on ne peut pas en sélectionner d'autres et on force les établissements à '*' également
    if (this.selectedSocs.some(s=>s.SocCod=="*") ){
      this.selectedSocs = this.lstUserEtbsXRP.filter(e=>e.SocCod=='*' && e.EtbCod=='*');
      this.model.Etbs = this.lstUserEtbsXRP.filter(e=>e.SocCod=='*' && e.EtbCod=='*');
    }
    if (this.model.Etbs.some(s=>s.EtbCod=="*") ){
      //Si on sélectionne l'établissement '*' sur certaines sociétés, on ne peut pas en sélectionner d'autres pour cette meme société
      let starSocs=this.model.Etbs.filter(s=>s.EtbCod=="*").map(s=>s.SocCod);
      this.model.Etbs = this.model.Etbs.filter(e=>starSocs.indexOf(e.SocCod)<0 || e.EtbCod=='*').distinctValues('EtbLib');
    }
    // recompute the etbs list as well (soc list doesn't depend on etbs)
    this.updatePerimeterLists();

    //On s'assure que les établissements sélectionnés soient accessibles pour les sociétés sélectionnées
    this.model.Etbs = this.model.Etbs
        .filter(item=> this.selectedSocs.some(uSoc=> item.SocCod==uSoc.SocCod || uSoc.SocCod=='*' || item.EtbCod=='*')).distinctValues('EtbLib');
  }

  displayReferent(item: PS_Lst_IntUsers_Result): string {
    if (!item) return '';
    return `${item?.Lastname} ${item?.Firstname} (${item?.ProfilLib})`;
  }

  public socsDispoFiltered  = this.socsDispo;
  public handleFilterSocs(value: string): void {
    this.socsDispoFiltered  = this.socsDispo.filter(e =>
        e.SocLib.toLowerCase().includes(value.toLowerCase())
    );
  }
  public etbsFiltered = this.etbsDispo;
  public handleFilterEtbs(value: string): void {
    this.etbsFiltered = this.etbsDispo.filter(e =>
        e.EtbLib.toLowerCase().includes(value.toLowerCase())
    );
  }
}
